/**
 * @class ProductInfo
 * @description Handles the quantity input outside the product form and sets the value to the product form for the correct add to cart submit.
 * @extends {HTMLElement}
 */
class ProductInfo extends HTMLElement {
  connectedCallback() {
    this.hasRun = false;

    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');

    this.reviewStarHeader = document.querySelector('.js-reviewStarHeader');
    this.reviewCounterHeader = document.querySelector('.js-reviewCounterHeader');
    this.reviewsWidget = document.querySelector('#reviews-widget');
    this.reviewsWrapper = document.querySelector('[data-product-rating-wrapper]');

    if (this.reviewsWidget) {
      this.lang = this.reviewsWidget.dataset.lang;
      this.showProductRating();
    }

    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    });

    this.observer = new MutationObserver(this.checkElements.bind(this));
    const observerOptions = {
      childList: true,
      subtree: true,
    };

    this.observer.observe(document.body, observerOptions);
    this.checkElements();
  }

  checkElements() {
    const reviewsPolaris = document.querySelector('#ReviewsWidget');
    const reviewsFilters = document.querySelectorAll('.R-DropUpDownMenu__inner');
    if (reviewsPolaris && reviewsFilters.length > 1 && !this.hasRun) {
      this.hasRun = true;
      this.observer.disconnect();

      setTimeout(() => {
        this.handleRatingLanguageWhenReady(reviewsPolaris, reviewsFilters);
      }, 500);
    }
  }

  handleRatingLanguageWhenReady(reviewsPolaris, reviewsFilters) {
    if (!reviewsPolaris || !reviewsFilters) {
      return;
    }

    const languageMap = {
      de: 'Deutsch',
      en: 'English',
      fr: 'Français',
      es: 'Español',
      it: 'Italiano',
    };

    reviewsFilters.forEach((filter, index) => {
      const wrapper = filter.getElementsByTagName('div')[0];
      const filterItems = wrapper.querySelectorAll('[role="button"]');

      // If going through the first filter dropdown, select the last item in the first group (best reviews)
      if (index === 0) {
        filterItems[filterItems.length - 1].click();
      } else {
        // On other filter dropdowns, try find the matching language.
        for (let i = 0; i < filterItems.length; i++) {
          const item = filterItems[i];
          const languageElement = item.querySelector('.R-flex-row > div');
          const languageText = languageElement?.textContent.trim();

          if (languageText && languageText.includes(languageMap[this.lang])) {
            setTimeout(() => {
              item.click();
            }, 300);
            break;
          }
        }
      }
    });
  }

  showProductRating() {
    if (!this.reviewCounterHeader || !this.reviewStarHeader) {
      return;
    }
    const reviewsioUrlKey = this.reviewsWidget.dataset.storeId;
    const productSkus = this.reviewsWidget.dataset.productSkus;
    this.reviewsWidget.dataset.lang;
    const skuApiUrl = `https://api.reviews.io/timeline/data?type=product_review&store=${reviewsioUrlKey}&sku=${productSkus}&enable_syndication=true&enable_avatars=true&include_subrating_breakdown=1`;
    fetch(skuApiUrl, {
      method: 'GET',
      headers: { accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        const reviewsIoRating = parseFloat(data.stats.average_rating);
        if (reviewsIoRating > 0) {
          this.reviewsWrapper.classList.remove('hidden');
          this.reviewsWrapper.classList.add('flex');
          this.reviewCounterHeader.innerHTML = reviewsIoRating.toFixed(1);
          let ratingHtml = '';
          for (let i = 1; i <= 5; i++) {
            if (Math.ceil(reviewsIoRating) >= i) {
              ratingHtml += '★ ';
            }
          }
          this.reviewStarHeader.innerHTML = ratingHtml;
        }
      })
      .catch((error) => {
        console.error('Error fetching product ratings:', error);
      });
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

customElements.define('product-info', ProductInfo);
